/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEveHelpViewProps } from './eve-help';

export default (props: IEveHelpViewProps) => {
    return (
        <>
            <div className={'eve-help-wrapper'}>{props.helpButton}</div>

            {props.modalBody}
        </>
    );
};
